import React, { Component } from "react";
import Button from "../../Button/Button";
import Progress from "../Progress/Progress";
import "./Form.css";

class Form extends Component {
	// Initial signup form before onboarding
	render() {
		return (
			<div className="signup-form">
				<div className="signup-form-l container">
					<Progress
						onboardingStepBuyer={this.props.onboardingStepBuyer}
						onboardingFlowBuyer={this.props.onboardingFlowBuyer}
					/>
					<form onSubmit={e => this.props.nextOnboardingBuyer(e)}>
					
						<label><b>1. Email</b> (used to receive report)</label>
						<input type="email" placeholder="e.g. info@fmeasure.com" autoComplete="email" value={this.props.signUpParamsBuyer['email']} onChange={e => this.props.onChangeInput('email', e.target.value, 'signUpParamsBuyer')}/>
					
						<label>2. Your name [optional]</label>
						<input type="text" placeholder="e.g. John Smith" autoComplete="name" value={this.props.signUpParamsBuyer['name']} onChange={e => this.props.onChangeInput('name', e.target.value, 'signUpParamsBuyer')}/>

						<label>3. Your company's name [optional]</label>
						<input type="text" placeholder="e.g. FMeasure Inc." value={this.props.signUpParamsBuyer['company_name']} onChange={e => this.props.onChangeInput('company_name', e.target.value, 'signUpParamsBuyer')}/>
						
						<label>4. Your company's website [optional]</label>
						<input type="text" placeholder="e.g. www.fmeasure.com" autoComplete="web" value={this.props.signUpParamsBuyer['web']} onChange={e => this.props.onChangeInput('web', e.target.value, 'signUpParamsBuyer')}/>
						
						<label>5. Location(s) of your company [optional]</label>
						<label> Separate different locations with ";"</label>
						<input type="text" placeholder="e.g. New York, USA" value={this.props.signUpParamsBuyer['location']} onChange={e => this.props.onChangeInput('location', e.target.value, 'signUpParamsBuyer')}/>
						
						
						<Button label="Next" />
					</form>
				</div>
			</div>
		);
	}
}

export default Form;


// WEBPACK FOOTER //
// ./src/components/BuyerList/Form/Form.js